export default __webpack_public_path__ + "static/pendantback-e0a7f60072592f4b9633211dbbd5a6c7.png";